import { RsuiteTimePicker } from "@components/adapters/rsuite/TimePicker";
import type { TimePickerProps } from "@components/contracts/TimePicker.types";

export const TimePicker: React.FC<TimePickerProps> = (props) => (
  <RsuiteTimePicker {...props} />
);

export type { TimePickerProps };
